import tippy from 'static-components/src/tippy';
var initializeTippy = function () {
    setTimeout(function () { new tippy(); }, 0);
};
export default initializeTippy;
